import { useEffect } from 'react';
import { useUserSettings } from '../stores/settingsRegistry';

const NOTIFICATION_TITLE = 'EdgeRunner';
const NOTIFICATION_BODY = 'EdgeRunner is done generating';

function notifyGenerationCompleteWeb(): void {
	if (typeof Notification === 'undefined') return;
	if (Notification.permission !== 'granted') return;
	if (document.hasFocus()) return;

	try {
		const n = new Notification(NOTIFICATION_TITLE, { body: NOTIFICATION_BODY });
		n.onclick = () => {
			window.focus();
			n.close();
		};
	} catch {
		// Permission revoked or browser blocked the constructor — silent no-op.
	}
}

function requestWebNotificationPermission(): void {
	if (typeof Notification === 'undefined') return;
	if (Notification.permission !== 'default') return;
	void Notification.requestPermission().catch(() => {
		// Browser policy may reject the request outside a user gesture — silent no-op.
	});
}

export function useGenerationCompleteNotifier(): void {
	const settings = useUserSettings();
	const enabled = settings.helpers.getValue('notifications.generationComplete') as boolean;

	useEffect(() => {
		const electron = (window as Window & {
			electron?: { notifyGenerationDone?: () => void };
		}).electron;
		if (!electron?.notifyGenerationDone) {
			requestWebNotificationPermission();
		}
	}, []);

	useEffect(() => {
		const handler = () => {
			const electron = (window as Window & {
				electron?: { notifyGenerationDone?: () => void };
			}).electron;

			if (electron?.notifyGenerationDone) {
				if (!enabled) return;
				electron.notifyGenerationDone();
			} else {
				notifyGenerationCompleteWeb();
			}
		};

		window.addEventListener('chat-completion-finished', handler);
		return () => {
			window.removeEventListener('chat-completion-finished', handler);
		};
	}, [enabled]);
}
